// src/api/api.js
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// Helper to attach Bearer token when available
const authHeaders = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export const API = {
  // products
  getProducts: `${BASE_URL}/products`,
  getProductById: (id) => `${BASE_URL}/editproducts/${id}`,
  addProduct: `${BASE_URL}/addproducts`,
  updateProduct: (id) => `${BASE_URL}/updateproducts/${id}`,
  deleteProduct: (id) => `${BASE_URL}/deleteproducts/${id}`,
  imagePath: `${BASE_URL}/uploads/`,

  // auth
  login: `${BASE_URL}/auth/login`,
  signup: `${BASE_URL}/auth/signup`,
  googleLogin: `${BASE_URL}/auth/google`,
  logout: `${BASE_URL}/auth/logout`,
  me: `${BASE_URL}/auth/me`,
};

export const IMAGE_PATH = `${BASE_URL}/uploads/`;

/* ---------------- CART (protected) ---------------- */
export const fetchCart = () =>
  axios.get(`${BASE_URL}/cart`, { headers: { ...authHeaders() } });

export const addToCart = (product_id, quantity = 1, variant_id = null) =>
  axios.post(
    `${BASE_URL}/cart/add`,
    { product_id, quantity, variant_id },   // ✅ SEND VARIANT
    { headers: { ...authHeaders() } }
  );

export const removeFromCart = (productId, variantId = null) =>
  axios.delete(
    `${BASE_URL}/cart/remove/${productId}`,
    {
      params: { variant_id: variantId },
      headers: { ...authHeaders() }
    }
  );
// Optional: only if you added PUT /api/cart/quantity on backend
export const setCartQuantity = (product_id, quantity, variant_id = null) =>
  axios.put(
    `${BASE_URL}/cart/quantity`,
    { product_id, quantity, variant_id },
    { headers: { ...authHeaders() } }
  );
/* ---------------- AUTH ---------------- */
export const fetchUser = () =>
  axios.get(API.me, { headers: { ...authHeaders() } });

/* ---------------- SEARCH / RECENT ---------------- */
export const searchProducts = (query) =>
  axios.get(`${BASE_URL}/products/search`, {
    params: { q: query },
  });

export const getRecentProducts = () =>
  axios.get(`${BASE_URL}/products/recent`);

/* ---------------- PAYMENTS (protected) ---------------- */
export const createPaymentOrder = (payload) =>
  axios.post(
    `${BASE_URL}/payments/create-order`,
    payload,
    { headers: { 'Content-Type': 'application/json', ...authHeaders() } }
  );

export const getPaymentOrderStatus = (orderId) =>
  axios.get(
    `${BASE_URL}/payments/order/${orderId}/status`,
    { headers: { ...authHeaders() } }
  );

export const getPaymentOrderDetails = (localOrderId) =>
  axios.get(
    `${BASE_URL}/payments/orders/${localOrderId}`,
    { headers: { ...authHeaders() } }
  );


async function authFetch(url, options = {}) {
  const res = await fetch(url, {
    ...options,
    headers: { 'Content-Type': 'application/json', ...authHeader(), ...(options.headers || {}) },
  });
  if (res.status === 401) {
    // optionally: localStorage.removeItem('token'); window.location.href = '/login';
  }
  let data;
  try {
    data = await res.json();
  } catch {
    const text = await res.text();
    throw new Error(text || 'Unexpected response');
  }
  if (!res.ok) {
    throw new Error(data?.error || data?.message || 'Request failed');
  }
  return data;
}



const authHeader = () => {
  const token = localStorage.getItem('token');
  return token ? { Authorization: `Bearer ${token}` } : {};
};
export const ORDERS_API = {
  my: (status) => `${BASE_URL}/orders/my${status ? `?status=${encodeURIComponent(status)}` : ''}`,
  details: (id) => `${BASE_URL}/orders/my/${id}`,

  // request-based (admin + DB)
  requestCancel: (id) => `${BASE_URL}/orders/my/${id}/request-cancel`,
  requestRefund: (id) => `${BASE_URL}/orders/my/${id}/request-refund`,
};

// list / detail
export function fetchMyOrders(status) {
  return authFetch(ORDERS_API.my(status));
}
export function fetchOrderDetails(id) {
  return authFetch(ORDERS_API.details(id));
}

// request-based actions
export function createCancelRequest(orderId, reason) {
  return authFetch(ORDERS_API.requestCancel(orderId), {
    method: 'POST',
    body: JSON.stringify({ reason }),
  });
}
export function createRefundRequest(orderId, amount, reason) {
  return authFetch(ORDERS_API.requestRefund(orderId), {
    method: 'POST',
    body: JSON.stringify({ amount, reason }),
  });
}



export const getCatalogues = (includeProducts = true) =>
  axios.get(`${BASE_URL}/catalogues`, {
    params: { includeProducts },
  });
